
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"31","height":"31","viewBox":"0 0 31 31","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".5","y":".3","width":"30","height":"30","rx":"15","fill":"#F0F1F2"}}),_c('g',{attrs:{"clip-path":"url(#upcoming_svg__clip0_2680_202)"}},[_c('path',{attrs:{"d":"M15.5 8.228a2.837 2.837 0 00-2.829 2.829v1.414h-1.237c-.877 0-1.591.714-1.591 1.591v6.718c0 .877.714 1.591 1.59 1.591h8.133c.877 0 1.591-.714 1.591-1.59v-6.719c0-.877-.714-1.59-1.591-1.59h-1.238v-1.415A2.837 2.837 0 0015.5 8.228zm0 1.061a1.76 1.76 0 011.768 1.768v1.414h-3.536v-1.414A1.76 1.76 0 0115.5 9.289zm0 7.071a1.06 1.06 0 110 2.122 1.06 1.06 0 010-2.122z","fill":"#3F4A58"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"upcoming_svg__clip0_2680_202"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(9.843 8.228)","d":"M0 0h11.314v14.143H0z"}})])])])
          )
        }
      }
    